import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/routers'

Vue.use(VueRouter)

export const router = new VueRouter({
  base: '/iform',
  mode: 'history',
  routes
})

Vue.router = router

export default {
  router
}
